import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-bonus-amount',
  templateUrl: './bonus-amount.component.html',
  styleUrls: ['./bonus-amount.component.css']
})
export class BonusAmountComponent implements OnInit {

  isLoading = true;
  amountData: any[] = [];

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.isLoading = true;
    const id = localStorage.getItem('user_id');

    this.apiService.getUserReferals(id).subscribe(
      (response) => {
        this.amountData = response.listOfReferals || [];
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching referrals:', error);
        this.isLoading = false;
      }
    );
  }

  // bonusAmount string ho ya number, dono se total nikal lo
  get totalBonus(): number {
    return this.amountData.reduce((sum, r) => {
      const n = parseFloat(String(r.bonusAmount).replace(/[^0-9.\-]/g, ''));
      return sum + (isNaN(n) ? 0 : n);
    }, 0);
  }
}
